var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6809_20024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73245 20.7164C6.14595 20.7164 7.29181 19.5705 7.29181 18.157C7.29181 16.7435 6.14595 15.5977 4.73245 15.5977C3.31896 15.5977 2.1731 16.7435 2.1731 18.157C2.1731 19.5705 3.31896 20.7164 4.73245 20.7164Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1992 18.4466C22.426 18.4466 23.4206 17.452 23.4206 16.2252C23.4206 14.9984 22.426 14.0039 21.1992 14.0039C19.9724 14.0039 18.9779 14.9984 18.9779 16.2252C18.9779 17.452 19.9724 18.4466 21.1992 18.4466Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1711 7.24326C20.1845 7.24326 21.0061 6.4217 21.0061 5.40825C21.0061 4.3948 20.1845 3.57324 19.1711 3.57324C18.1576 3.57324 17.3361 4.3948 17.3361 5.40825C17.3361 6.4217 18.1576 7.24326 19.1711 7.24326Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71606 14.4686C4.21609 14.4686 5.43211 13.2823 5.43211 11.8188C5.43211 10.3553 4.21609 9.16895 2.71606 9.16895C1.21602 9.16895 0 10.3553 0 11.8188C0 13.2823 1.21602 14.4686 2.71606 14.4686Z",
    fill: "#70706F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5185 23.9996C11.8821 23.9996 12.9876 22.9224 12.9876 21.5935C12.9876 20.2647 11.8821 19.1875 10.5185 19.1875C9.15479 19.1875 8.04932 20.2647 8.04932 21.5935C8.04932 22.9224 9.15479 23.9996 10.5185 23.9996Z",
    fill: "#B6B6B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8642 22.9459C18.1597 22.9459 19.2099 21.9233 19.2099 20.6619C19.2099 19.4005 18.1597 18.3779 16.8642 18.3779C15.5687 18.3779 14.5186 19.4005 14.5186 20.6619C14.5186 21.9233 15.5687 22.9459 16.8642 22.9459Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6543 8.31486C7.22251 8.31486 8.49379 7.07393 8.49379 5.54317C8.49379 4.01241 7.22251 2.77148 5.6543 2.77148C4.0861 2.77148 2.81482 4.01241 2.81482 5.54317C2.81482 7.07393 4.0861 8.31486 5.6543 8.31486Z",
    fill: "#545453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9013 12.5132C23.0604 12.5132 24 11.591 24 10.4534C24 9.31578 23.0604 8.39355 21.9013 8.39355C20.7421 8.39355 19.8025 9.31578 19.8025 10.4534C19.8025 11.591 20.7421 12.5132 21.9013 12.5132Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7003 5.98793C14.3538 5.98793 15.6942 4.64748 15.6942 2.99396C15.6942 1.34044 14.3538 0 12.7003 0C11.0467 0 9.7063 1.34044 9.7063 2.99396C9.7063 4.64748 11.0467 5.98793 12.7003 5.98793Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6809_20024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.a67e29ea.svg";
export { ForwardRef as ReactComponent };var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpinner(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6809_20024)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73245 20.7164C6.14595 20.7164 7.29181 19.5705 7.29181 18.157C7.29181 16.7435 6.14595 15.5977 4.73245 15.5977C3.31896 15.5977 2.1731 16.7435 2.1731 18.157C2.1731 19.5705 3.31896 20.7164 4.73245 20.7164Z",
    fill: "#909090"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1992 18.4466C22.426 18.4466 23.4206 17.452 23.4206 16.2252C23.4206 14.9984 22.426 14.0039 21.1992 14.0039C19.9724 14.0039 18.9779 14.9984 18.9779 16.2252C18.9779 17.452 19.9724 18.4466 21.1992 18.4466Z",
    fill: "#CDCDCD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1711 7.24326C20.1845 7.24326 21.0061 6.4217 21.0061 5.40825C21.0061 4.3948 20.1845 3.57324 19.1711 3.57324C18.1576 3.57324 17.3361 4.3948 17.3361 5.40825C17.3361 6.4217 18.1576 7.24326 19.1711 7.24326Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71606 14.4686C4.21609 14.4686 5.43211 13.2823 5.43211 11.8188C5.43211 10.3553 4.21609 9.16895 2.71606 9.16895C1.21602 9.16895 0 10.3553 0 11.8188C0 13.2823 1.21602 14.4686 2.71606 14.4686Z",
    fill: "#70706F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5185 23.9996C11.8821 23.9996 12.9876 22.9224 12.9876 21.5935C12.9876 20.2647 11.8821 19.1875 10.5185 19.1875C9.15479 19.1875 8.04932 20.2647 8.04932 21.5935C8.04932 22.9224 9.15479 23.9996 10.5185 23.9996Z",
    fill: "#B6B6B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8642 22.9459C18.1597 22.9459 19.2099 21.9233 19.2099 20.6619C19.2099 19.4005 18.1597 18.3779 16.8642 18.3779C15.5687 18.3779 14.5186 19.4005 14.5186 20.6619C14.5186 21.9233 15.5687 22.9459 16.8642 22.9459Z",
    fill: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6543 8.31486C7.22251 8.31486 8.49379 7.07393 8.49379 5.54317C8.49379 4.01241 7.22251 2.77148 5.6543 2.77148C4.0861 2.77148 2.81482 4.01241 2.81482 5.54317C2.81482 7.07393 4.0861 8.31486 5.6543 8.31486Z",
    fill: "#545453"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9013 12.5132C23.0604 12.5132 24 11.591 24 10.4534C24 9.31578 23.0604 8.39355 21.9013 8.39355C20.7421 8.39355 19.8025 9.31578 19.8025 10.4534C19.8025 11.591 20.7421 12.5132 21.9013 12.5132Z",
    fill: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7003 5.98793C14.3538 5.98793 15.6942 4.64748 15.6942 2.99396C15.6942 1.34044 14.3538 0 12.7003 0C11.0467 0 9.7063 1.34044 9.7063 2.99396C9.7063 4.64748 11.0467 5.98793 12.7003 5.98793Z",
    fill: "#343434"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6809_20024"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner);
export default __webpack_public_path__ + "static/media/Spinner.a67e29ea.svg";
export { ForwardRef as ReactComponent };